import React from "react";
import * as S from "./styles";
import { SwitchButton } from "..";

interface SwitchInput {
  checked: boolean;
  label: string;
  onChange: () => void;
  title: string;
  width?: string;
  height?: string;
  disabled?: boolean;
}

export const SwitchInput = React.forwardRef<HTMLButtonElement, SwitchInput>(
  (
    { checked, label, height, onChange, title, width, disabled = false },
    ref,
  ) => {
    return (
      <S.SwitchContainer width={width} height={height}>
        <span>{title}</span>
        <S.ButtonWrapper ref={ref} type="button" disabled={disabled}>
          <SwitchButton
            onChange={onChange}
            checked={checked}
            disabled={disabled}
          />
          <span>{label}</span>
        </S.ButtonWrapper>
      </S.SwitchContainer>
    );
  },
);
